export default import.meta.ROLLUP_FILE_URL_Dgo$Z9jX;